import React, { useEffect, useState } from 'react';
import { Paginator } from 'primereact/paginator';
import { useNavigate } from 'react-router-dom';
import { useStoreSelector, useAuthStatus, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { useRecommendationApi } from '../../store/api/hooks/recommendationApiHook';
import toast from 'react-hot-toast';
import moment from 'moment';
import Icon from '../../components/icons';
import Spinner from '../../components/iconSvgs/spinner';
import { RecommendationDataTableProps } from '../../_config/interfaces/interfaces';

const RecommendationDataTable: React.FC<RecommendationDataTableProps> = ({ filterValue }) => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [first, setFirst] = useState(1);
    const [perPage, setPerpage] = useState(10);
    const [page, setPage] = useState(1);
    const [isPagination, setIsPagination] = useState<boolean>(false)
    const [recommData, setRecommData] = useState<any[]>([]);
    const [totalcount, setTotalCount] = useState(0);
    const [hovered, setHovered] = useState<{ index: number | null, type: string | null }>({ index: null, type: null });

    const recommAPI = useRecommendationApi();
    const navigate = useNavigate();
    const branchDS = useStoreBrnDSSelector();

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue); // This is called automatically when filterValue changes
        } else {
            getRecommendationList({});
        }
    }, [filterValue]);

    const applyFilter = (filterValue: any) => {
        getRecommendationList(filterValue);
    }

    const getRecommendationList = (param: any) => {
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = {
                branch_id: branchDS?.branch_id, page: Math.floor(first / perPage) + 1,
                page_size: perPage, ...param
            };
        } else {
            params = {
                'branch_id': branchDS?.branch_id,
                'page': Math.floor(first / perPage) + 1, // Page is 1-based, adjust accordingly
                'page_size': perPage
            };
        }
        try {
            setTimeout(() => {
                recommAPI.getRecommendationList(params, (msg: any, resp: any) => {
                    if (resp && resp.data && resp.data.length > 0) {
                        setRecommData(resp.data);
                        setTotalCount(resp.pagination?.total_records || 0);
                        setIsPagination(true);
                    } else {
                        setRecommData([]);
                        setTotalCount(0);
                        setIsPagination(false);
                    }
                }, (err: any) => {
                    toast.error(err);
                });
                setOnSubmitLoading(false);
            }, 3000);
        } catch (e) {
            console.log('error =>', e);
            setOnSubmitLoading(false);
        }

    };

    const handlePageChange = (e: any) => {
        const newPage = e.page;
        const newFirst = e.first;
        const newRows = e.rows;

        if (newFirst !== first || newRows !== perPage) {
            setPage(newPage);
            setPerpage(perPage)
            setFirst(newFirst);

            let params: any;
            if (filterValue) {
                params = {
                    branch_id: branchDS?.branch_id, page: newPage + 1,
                    page_size: perPage, ...filterValue
                };
            } else {
                params = {
                    'branch_id': branchDS?.branch_id,
                    'page': newPage + 1, // Page is 1-based, adjust accordingly
                    'page_size': perPage
                };
            }
            getRecommendationList(params);
        }
    };


    return (
        <div>
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            <table className="min-w-full table-auto">
                <thead>
                    <tr className="bg-gray-100 text-left text-base font-semibold text-gray-600 p-4">
                        <th className="px-4 py-2" style={{ width: '300px' }}>Concerned Area</th>
                        <th className="px-4 py-2" style={{ width: '400px' }}>Suggestion</th>
                        <th className="px-4 py-2" style={{ width: '200px' }}>Severity</th>
                        <th className="px-4 py-2" style={{ width: '200px' }}>Implementation Priority</th>
                    </tr>
                </thead>
                <tbody>
                    {recommData.map((recom, index: any) => {
                        return (
                            <tr key={index} className={`border-b ${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}`}>
                                <td className="px-4 py-4 capitalize items-center justify-center">
                                    <div className='flex'>
                                        <span className='pb-3'>{recom.topic}</span>
                                    </div>
                                </td>
                                <td className="px-4 py-2">{recom.recommendation}</td>
                                <td className="px-4 py-2">{recom.severity}</td>
                                <td className="px-4 py-2">{recom.rank}</td>

                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {/* Pagination */}
            {isPagination && totalcount > 10 && (<div className="mt-4">
                <Paginator
                    first={first}
                    // rows={perPage}
                    rows={perPage}
                    totalRecords={totalcount}
                    // rowsPerPageOptions={[15, 30, 50]}
                    onPageChange={handlePageChange}
                    className="p-jc-center"
                />
            </div>)}
        </div>
    )

}

export default RecommendationDataTable;